import { render, staticRenderFns } from "./ExtraServiceLicense.vue?vue&type=template&id=648db1d2"
import script from "@/scripts/modal/extraService/extraServiceLicense.js?vue&type=script&lang=js&external"
export * from "@/scripts/modal/extraService/extraServiceLicense.js?vue&type=script&lang=js&external"
import style0 from "./ExtraServiceLicense.vue?vue&type=style&index=0&id=648db1d2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports